import axios from 'axios';
import { BASE_URL, CONTENT_API_PATH } from 'constants/api';

export interface ManualUploadShortsRequest {
  video_id: number;
  title: string;
  slug?: string;
  title_en?: string;
  season_id?: number | null;
  subtype?: 'vod' | 'live' | 'ad';
  original_content_id?: number | null;
  internal_title?: string;
  shorts_description?: string | null;
  /** BEE-5028: i18n description dict. BE 가 default lang (ko) 을 shorts_description 으로 sync. */
  i18n_shorts_description?: import('../../../../shared/types/i18n/i18nTypes').I18nFieldData | null;
  cta_type?: 'internal' | 'external' | 'none';
  start_timestamp?: number | null;
  cta_url?: string | null;
  impression_tracking_url?: string | null;
  cta_channel_id?: number | null;
  /** BEE-5022 LIVE flow: cta_channel_id 의 service namespace ('odk' | 'amasian'). */
  live_service?: 'odk' | 'amasian' | null;
}

export interface ManualUploadShortsResponse {
  shorts_content_id: number;
  video_id: number;
  transcode_submitted: number;
}

/** BEE-5022: POST /api/v1/content/manual-upload-shorts/ (ucms-be #844).
 *  video_video.id 가 이미 in-house 업로드로 만들어진 상태에서 shorts
 *  Content + ShortsMeta + ContentVideoAsset 한 번에 묶고 HLS transcode
 *  잡까지 submit. 결과로 새 shorts_content_id 반환. */
export const manualUploadShortsService = {
  async create(
    payload: ManualUploadShortsRequest,
  ): Promise<ManualUploadShortsResponse> {
    const response = await axios.post<ManualUploadShortsResponse>(
      `${BASE_URL}${CONTENT_API_PATH}manual-upload-shorts/`,
      payload,
    );
    return response.data;
  },
};
